{
	"ariaAutoStraighten": "Auto Straighten",
	"ariaConfirmCrop": "Confirm Crop",
	"ariaCropPanel": "Crop Panel",
	"ariaFlipCropAspectRatio": "Flip Crop Aspect Ratio",
	"ariaFlipCropHorizontal": "Flip Crop Horizontal",
	"ariaFlipCropVertical": "Flip Crop Vertical",
	"ariaLockCropAspectRatio": "Lock Crop Aspect Ratio",
	"ariaResetCrop": "Reset Crop",
	"ariaRotateCropLeft": "Rotate Crop Left",
	"ariaRotateCropRight": "Rotate Crop Right",
	"autoStraighten": "Auto",
	"rotateAndFlip": "Rotate & Flip",
	"sliderStraighten": "Straighten"
}
